import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Carmen R., 68 años',
    location: 'Miami, FL',
    text: 'Llevaba años despertando con las manos tan rígidas que no podía ni abrir el frasco del café. Empecé a hacer la Sopa de Pescado y Coco en las noches. En solo una semana, la hinchazón bajó muchísimo. ¡Y lo mejor es que solo ensucio una olla!',
    image: 'https://images.unsplash.com/photo-1581579186913-46ac3a6ef93f?auto=format&fit=crop&q=80&w=150&h=150'
  }, {
    name: 'Rosa M., 71 años',
    location: 'Houston, TX',
    text: 'A mi edad ya no quiero pasar horas en la cocina. El Picadillo de Pavo me salva las cenas. Duermo como un bebé y mis rodillas ya no crujen tanto por la mañana. Mi esposo también lo come y le encanta el sabor.',
    image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&q=80&w=150&h=150'
  }, {
    name: 'Elena G., 66 años',
    location: 'Los Angeles, CA',
    text: 'Pensé que comer sano significaba comer desabrido. ¡Qué equivocada estaba! El pollo con cúrcuma es delicioso. He notado que mis anillos ya no me aprietan en la mañana. Esta guía vale oro.',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=150&h=150'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-107">
      <div className="max-w-6xl mx-auto" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-bold text-[#5C3D2E] mb-6" data-id="element-110">
            Mujeres como tú ya están despertando sin dolor
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-111">
          {testimonials.map((testimonial, index) => <Card key={index} delay={index * 0.2} className="p-8 bg-[#FFFDF5] relative" data-id="element-112">
              <div className="flex gap-1 mb-4" data-id="element-113">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-[#D4A017] fill-current" data-id="element-114" />)}
              </div>
              <p className="text-lg text-[#5C3D2E] italic mb-6 relative z-10" data-id="element-115">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-116">
                <img src={testimonial.image} alt={testimonial.name} className="w-16 h-16 rounded-full object-cover border-2 border-[#D4A017]" data-id="element-117" />
                <div data-id="element-118">
                  <h4 className="font-bold text-[#5C3D2E]" data-id="element-119">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-[#5C3D2E] opacity-70" data-id="element-120">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}